module.exports = __webpack_public_path__ + "static/erinfola-fe0ae4b96121e3b19cce7213f597feae.png";